import moment from 'moment';
import { dateError, pickupDateError, tripCxlReasonError } from '../../constants/errors';
import { TripStatus } from '../../graphql/generated/api';
var validation = function (values) {
    var errors = {};
    if (!(values === null || values === void 0 ? void 0 : values.date)) {
        errors.date = pickupDateError;
    }
    if (values === null || values === void 0 ? void 0 : values.date) {
        var isDateValid = moment(values.date).isValid();
        if (!isDateValid) {
            errors.date = dateError;
        }
    }
    if ((values === null || values === void 0 ? void 0 : values.status) === TripStatus.CANCELED && !(values === null || values === void 0 ? void 0 : values.tripCxlReason)) {
        errors.tripCxlReason = tripCxlReasonError;
    }
    return errors;
};
export default validation;
//# sourceMappingURL=pickupDetails.js.map